export default __webpack_public_path__ + "static/media/marauders-map-v4-gallery-15.3712689d.jpg";